<template>
  <div class="l-breadcrumb">
    <ul class="breadcrumb-list">
      <template v-if="['story', 'announcement', 'activity-lesson', 'media'].includes(route.name)">
        <li class="breadcrumb-list__item" v-for="(b, idx) of breadcrumb" :key="b.key">
          <span
            class="breadcrumb-list__item__title"
            :class="{
              'breadcrumb-list__item__title--no-cursor': noLinks.includes(b.key),
            }"
            @click="toPage(b.key)"
            >{{ b.title }}</span
          >
          <img
            class="breadcrumb-list__item__icon"
            src="@/assets/icon/icon_arrow_small.svg"
            v-if="breadcrumb.length !== idx + 1"
          />
        </li>
        <li class="breadcrumb-list__item">
          <img class="breadcrumb-list__item__icon" src="@/assets/icon/icon_arrow_small.svg" />
          <span class="breadcrumb-list__item__title breadcrumb-list__item__title--active">{{ extraBreadcrumb }}</span>
        </li>
      </template>

      <template v-else>
        <li class="breadcrumb-list__item" v-for="(b, idx) of breadcrumb" :key="b.key">
          <span
            class="breadcrumb-list__item__title"
            :class="{
              'breadcrumb-list__item__title--no-cursor': noLinks.includes(b.key),
              'breadcrumb-list__item__title--active': breadcrumb.length - 1 === idx,
            }"
            @click="toPage(b.key)"
            >{{ b.title }}
          </span>

          <!-- 自我檢測才會有這問題，因為題數剛好掛在 params 上要特別處理 -->
          <template v-if="['mom', 'home-care'].includes(route.name)">
            <img
              class="breadcrumb-list__item__icon"
              src="@/assets/icon/icon_arrow_small.svg"
              v-if="breadcrumb.length !== idx + 1 && breadcrumb.length !== idx + 2"
            />
          </template>

          <template v-else>
            <img
              class="breadcrumb-list__item__icon"
              src="@/assets/icon/icon_arrow_small.svg"
              v-if="breadcrumb.length !== idx + 1"
            />
          </template>
        </li>
      </template>
    </ul>
  </div>
</template>
<script>
import {
  defineComponent, watch, ref, computed,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { routeNameMapping } from '@/config/routeMappingConfig';
import { useExtraBreadcrumbStore } from '@/store/extraBreadcrumb';

export default defineComponent({
  name: 'Breadcrumb',
  setup() {
    const extraBreadcrumbStore = useExtraBreadcrumbStore();
    const route = useRoute();
    const router = useRouter();
    const breadcrumb = ref([]);
    const noLinks = ref(['foundation', 'services', 'news', 'resources', 'society', 'donate']);
    const extraBreadcrumb = computed(() => extraBreadcrumbStore.extraBreadcrumb);

    const parseUrl = () => {
      const path = route.path.substr(1).split('/');
      const pagesBreadcrumb = path.map((routePath) => ({
        key: routePath,
        title: routeNameMapping[routePath],
      }));

      breadcrumb.value = [
        {
          key: 'home',
          title: '首頁',
        },
        ...pagesBreadcrumb,
      ];
    };

    parseUrl();

    const toPage = (r) => {
      if (noLinks.value.includes(r)) return;
      if (!r) return;

      let routeName = r;

      // 如果在文章列表的頁面，導回列表
      const specialRoutesMapping = {
        story: 'stories',
        announcement: 'announcements',
        'activity-lesson': 'activity-lessons',
        media: 'medias',
      };

      const specialRouteKey = Object.keys(specialRoutesMapping);

      if (specialRouteKey.includes(route.name)) {
        routeName = specialRoutesMapping[r];
      }

      router.push({
        name: routeName,
      });
    };

    watch(route, () => {
      parseUrl();
    });

    const showArrow = (len, idx) => {
      if (['mom', 'home-care'].includes(route.name)) {
        // 不解析題數
        return len !== idx + 1 && len !== idx + 2;
      }
      return len !== idx + 1;
    };

    return {
      breadcrumb,
      route,
      router,
      toPage,
      showArrow,
      extraBreadcrumb,
      noLinks,
    };
  },
});
</script>
<style lang="scss" scoped>
.l-breadcrumb {
  margin-bottom: 100px;
}
.breadcrumb-list {
  // @include flex(flex-start);
  margin-top: 40px;

  &__item {
    display: inline-block;
    vertical-align: middle;

    &__title {
      color: $c-main;
      cursor: pointer;
      line-height: 28px;

      &--no-cursor {
        cursor: auto;
      }

      &--active {
        opacity: 0.5;
        cursor: default;
      }
    }

    &__icon {
      padding: 0 10px;
    }
  }
}
</style>
